module.exports = __webpack_public_path__ + "static/media/cakey.8e169342.png";